import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=641bc8f0"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641bc8f0')) {
      api.createRecord('641bc8f0', component.options)
    } else {
      api.reload('641bc8f0', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=641bc8f0", function () {
      api.rerender('641bc8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Terms.vue"
export default component.exports